/**
 * 上傳影片到 Cloudflare Stream。
 *
 * Endpoint 與 request body 因 caller 而異（post / chat），由 caller 提供。
 *
 * @param {File}     file
 * @param {Function} getUploadUrl - () => Promise<AxiosResponse>，向後端取得 CF 上傳 URL
 * @returns {Promise<{uid: string}>}
 * @throws  {Error}  GET_UPLOAD_URL_FAILED / CF_UPLOAD_FAILED
 */
export const uploadVideoToCF = async (file, getUploadUrl) => {
  const urlRes = await getUploadUrl();
  if (urlRes.data.status_code !== 'SYSTEM_1000') {
    throw new Error('GET_UPLOAD_URL_FAILED');
  }

  const { uid, upload_url } = urlRes.data.data;
  const cfFormData = new FormData();
  cfFormData.append('file', file);
  const cfRes = await fetch(upload_url, { method: 'POST', body: cfFormData });
  if (!cfRes.ok) {
    throw new Error('CF_UPLOAD_FAILED');
  }

  return { uid };
};
